import { TransferAccount } from '@ally/data-types-transfer-accounts'
import { isInvest } from '@ally/transfer-account-utils'

export function getFromAccounts(
  accounts: TransferAccount[],
): TransferAccount[] {
  return accounts.filter(
    account => account.isTransferEligibleFrom || isInvest(account),
  )
}
